export type NonEmptyArray<T> = T[] & { 0: T };

export function isNonEmptyArray<T>(
  arr: Array<T> | undefined | null,
): arr is NonEmptyArray<NonNullable<typeof arr>[number]> {
  return Array.isArray(arr) && arr.length > 0;
}

export type ArrayElement<ArrayType extends unknown[] | undefined | null> =
  NonNullable<ArrayType>[number];

export const getArrayDepth = (value: unknown): number => {
  return Array.isArray(value) ? 1 + Math.max(0, ...value.map(getArrayDepth)) : 0;
};
